<script setup lang="ts">
const { openDepositModal } = usePayments();
const casinoStore = useCasinoStore();
const { updateWallet } = useWallet();
const { lastPreviewGame, reopenLastPreview } = useGameMobilePreview();
const router = useRouter();

// iOS: a barra e fixed top:0, entao no notch/Dynamic Island os botoes
// (voltar/depositar) ficam sob o recorte. Reserva a safe area do topo.
const isIosApp = useIsIosNativeApp();

type Emits = {
  'full-screen-off': [];
};

const emit = defineEmits<Emits>();

function backHome() {
  emit('full-screen-off');
  casinoStore.isGameModalOpen = false;
  updateWallet();

  // Veio do MobilePreview: volta pra rota anterior e reabre o preview
  // no jogo que estava sendo visualizado. Quando não há histórico (entrada
  // direta via deeplink ?direct=true), navega pra home pra que o preview
  // tenha onde renderizar como overlay sobre o conteúdo principal.
  if (lastPreviewGame.value) {
    const hasHistory = !!window.history.state?.back;

    if (hasHistory) {
      router.back();
    } else {
      router.push('/');
    }

    reopenLastPreview();
  }
}

onBeforeRouteLeave(() => {
  casinoStore.isGameModalOpen = false;
});
</script>

<template>
  <div
    class="gamesBar flex flex-col items-center w-full"
    :class="{ hidden: !casinoStore.isGameModalOpen, 'ios-safe-top': isIosApp }"
  >
    <div
      class="menu flex flex-row items-center justify-between w-full h-10 px-2 border-bg-primary/60 border-b border-solid"
    >
      <div class="flex justify-start items-center w-1/3">
        <NuxtIcon
          class="menuBtn home"
          name="arrows/angle_left"
          @click="backHome"
        />
      </div>

      <BaseCommonLogo
        allow-redirect
        always-logo
        class="justify-center logo w-1/3 px-4 py-0.5 logo-header-center"
      />

      <div class="deposit flex justify-end w-1/3">
        <button
          class="btn btn-cta btn-deposit"
          @click="openDepositModal()"
        >
          {{ $t('header.deposit') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.gamesBar {
  @apply bg-bg-secondary w-full fixed top-0 left-0 z-[99999];
  /* `.ios-safe-top` (global, em main.scss) empurra os botoes pra baixo do
     notch quando no app iOS; o fundo (bg-bg-secondary) preenche a area. */

  .menu {
    .menuBtn {
      @apply text-primary cursor-pointer inline-flex items-center justify-center;
    }

    .btn-deposit {
      @apply text-xs font-medium shadow-primary relative lg:hidden;
      height: 1.7rem;
      @apply px-3;

      &:after {
        content: '';
        box-shadow: 0 0 10px var(--tw-shadow-color);

        @apply absolute top-0 left-0 w-full h-full opacity-60;
      }
    }
  }
}
</style>
